import { Column, Entity, JoinColumn, ManyToOne, OneToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IPreliminaryInterview } from './interface/IPreliminaryInterview';
import { IRefSupervision } from './interface/IRefSupervision';
import { IRefWithAttendant } from './interface/IRefWithAttendant';
import { IVerification } from './interface/IVerification';

@Entity('preliminary_interview')
export class PreliminaryInterview extends BaseEntity implements IPreliminaryInterview{
  apiMapping = {
    hasMaterial: 'hasMaterial',
    refWithAttendantId: {
      fieldName: 'refWithAttendant',
      type: 'RefWithAttendant'
    },
      attendantName: 'attendantName',
    attendantJobName: 'attendantJobName',
    attendantComment: 'attendantComment',
    hasAccessProvided: 'hasAccessProvided',
    accessProvidedName: 'accessProvidedName',
    accessProvidedReason: 'accessProvidedReason',
    hasInstallationProvided: 'hasInstallationProvided',
    installationProvidedName: 'installationProvidedName',
    installationProvidedReason: 'installationProvidedReason',
    hasModifications: 'hasModifications',
    hasNotifications: 'hasNotifications',
    notificationsDetails: 'notificationsDetails',
    modificationsDetails: 'modificationsDetails',
    hasEvents: 'hasEvents',
    eventsDetails: 'eventsDetails',
    isSecurityRegistryShown: 'isSecurityRegistryShown',
    refSupervisionId: {
      fieldName: 'refSupervision',
      type: 'RefSupervision'
    },
    supervisionDetails: 'supervisionDetails'
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column({ nullable: true })
  hasMaterial: boolean;

  @Column({ nullable: true })
  attendantName: string;

  @Column({ nullable: true })
  attendantJobName: string;

  @Column({ nullable: true })
  attendantComment: string;

  @Column({ nullable: true })
  hasAccessProvided: boolean;

  @Column({ nullable: true })
  accessProvidedName: string;

  @Column({ nullable: true })
  accessProvidedReason: string;

  @Column({ nullable: true })
  hasInstallationProvided: boolean;

  @Column({ nullable: true })
  installationProvidedName: string;

  @Column({ nullable: true })
  installationProvidedReason: string;

  @Column({ nullable: true })
  hasModifications: boolean;

  @Column({ nullable: true })
  modificationsDetails: string;

  @Column({ nullable: true })
  hasEvents: boolean;

  @Column({ nullable: true })
  eventsDetails: string;

  @Column({ nullable: true })
  hasNotifications: boolean;

  @Column({ nullable: true })
  notificationsDetails: string;

  @Column({ nullable: true })
  isSecurityRegistryShown: boolean;

  @Column({ nullable: true })
  supervisionDetails: string;

  @ManyToOne('RefSupervision', { eager: true })
  refSupervision: IRefSupervision;

  @ManyToOne('RefWithAttendant', { eager: true })
  refWithAttendant: IRefWithAttendant;

  @OneToOne('Verification', 'preliminaryInterview', { eager: true })
  @JoinColumn()
  verification: IVerification;
}
